import { useCallback } from 'react'

import { useEquipmentNodeActions } from '@web/entities/equipment'
import type { IEquipmentNode } from '@web/entities/equipment/model/types'
import { useSseSubscription } from '@web/shared/hooks/use-sse-subscription.hook'
import { safeJson } from '@web/shared/utils/safe-json.util'

enum EEventType {
  NODES = 'nodes',
  PING = 'ping'
}

const isEventType = (v?: string): v is EEventType =>
  v ? (Object.values(EEventType) as string[]).includes(v) : false

export const useSseEquipmentNodes = () => {
  const { setNodes } = useEquipmentNodeActions()

  const handleMessage = useCallback(
    ({ data, event }: { data: string; event?: string }) => {
      const evt = isEventType(event) ? event : null

      if (evt !== EEventType.NODES) {
        return
      }

      const nodes = safeJson<IEquipmentNode[]>(data)
      setNodes(nodes ?? [])
    },
    [setNodes]
  )

  useSseSubscription({
    url: '/sse/configurator/nodes-state/get-all-nodes',
    onMessage: handleMessage
  })
}
